export default __webpack_public_path__ + "static/media/dairy-free.75710bf9.svg";